import { ghostApiSimpleWrapper } from '@maxpreps/network/src/simpleWrapper';

export const getBasicUserById = async (userId, token) =>
  ghostApiSimpleWrapper(`/users/basic-users/${userId}/v1`, { token });

export const getUserRoles = async (userId, options = undefined) =>
  ghostApiSimpleWrapper(`/users/${userId}/roles/public/v1`, options);

export const postUserFavoriteTeam = async (userId, payload, token) =>
  ghostApiSimpleWrapper(`/users/${userId}/favorite-teams/v1`, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'mp-sources-page-source': 'Desktop_CoachAdmin'
    },
    token
  });

export const postUserRemoveFavoriteTeam = async (
  userId,
  userFavoriteTeamRefId,
  token
) =>
  ghostApiSimpleWrapper(
    `/users/${userId}/favorite-teams/${userFavoriteTeamRefId}/v1`,
    {
      method: 'DELETE',
      headers: {
        'mp-sources-page-source': 'Desktop_CoachAdmin'
      },
      token
    }
  );
